module.exports = __webpack_public_path__ + "dd010a1aa5d342ebc519699cc51cb136.png";